import React from 'react';
import { useNavigate } from 'react-router-dom';


const MainPage = () => {
  const navigate = useNavigate();

  // const handleKakaoLogin = () => {
  //   const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=4c5fdbe5855234e85f75d180c278f846&redirect_uri=https://bapfriend.com/app/auth/kakao/callback&response_type=code`;
  //   window.location.href = KAKAO_AUTH_URL;
  // };

  return (
    <div className="h-screen flex flex-col bg-white px-6">
      {/* 로고 영역 (1/3 높이) */}
      <div className="flex justify-center items-center h-1/3">
        <div className="w-full max-w-sm">
          <img src="/images/bapfriend_banner02.png" alt="밥친구 로고" className="w-full h-auto" />
        </div>
      </div>

      {/* 배너 영역 (1/3 높이) */}
      <div className="flex justify-center items-center h-1/3">
        <div className="w-72 h-72 flex justify-center items-center rounded-lg text-gray-600 text-lg">
          <img src="/images/bap_banner.jpg" alt="밥친구 배너" />
        </div>
      </div>

      {/* 버튼 영역 (1/3 높이) */}
      <div className="flex flex-col justify-center items-center h-1/3">
        <div className="bg-gray-100 rounded-2xl p-4 w-full max-w-sm">
          <div className="flex flex-col space-y-4">
        { /* 카카오 로그인 버튼 */}
        {/*<button*/}
        {/*    onClick={handleKakaoLogin}*/}
        {/*        className="w-full flex items-center justify-center"*/}
        {/*  >*/}
        {/*    <img*/}
        {/*      src="/images/kakao_login_large_wide.png"*/}
        {/*      alt="카카오 로그인 버튼"*/}
        {/*      className="w-full h-auto"*/}
        {/*    />*/}
        {/*</button>*/}

        {/* 구분선 */}
        {/*    <div className="w-full flex items-center justify-center space-x-4">*/}
        {/*  <div className="flex-1 h-px bg-gray-300"></div>*/}
        {/*  <span className="text-gray-500 text-sm">또는</span>*/}
        {/*  <div className="flex-1 h-px bg-gray-300"></div>*/}
        {/*</div>*/}

        {/* 로그인/회원가입 버튼 */}
            <div className="w-full relative">
              {/* 말풍선 */}
              <div className="absolute -top-7 right-0">
                <div className="relative">
                  <div className="bg-amber-100  text-amber-700 text-xs px-3 py-1 rounded-full shadow-sm">
                    전화번호로 간편하게 회원가입
                  </div>
                  <div className="absolute right-6 -bottom-1 w-2 h-2 bg-amber-100 rotate-45"></div>
                </div>
              </div>
              <div className="w-full flex space-x-4">
                <button
                  onClick={() => navigate('/app/login')}
                  className="flex-1 py-2 bg-amber-500 text-white rounded-lg font-bold">
                  로그인
                </button>
                <button
                  onClick={() => navigate('/app/signup')}
                  className="flex-1 py-2 bg-gray-200 text-gray-700 rounded-lg font-bold">
                  회원가입
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPage;
